import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../../../layouts/Dashboard'
import { Warning } from 'phosphor-react'

import { Col, Row, Container, Badge } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { errorApi } from '../../../../utils/errorApi'
import api from '../../../../services/api'

import VeiculoRotaDiaria from '../VeiculoRotaDiaria'
import VehicleHistorical from '../../../../components/Vehicle/VehicleHistorical'
import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner'

const Entregas: React.FC = () => {
  let { id } = useParams()
  const { isLoading, setIsLoading } = useLoading()
  const [requests, setRequests] = useState<any>([])
  const [vehicleDayStats, setVehicleDayStats] = useState<any>({})

  useEffect(() => {
    async function loadWaypointsData() {
      setIsLoading(true)
      try {
        const today = new Date().toISOString().split('T')[0]
        const { data } = await api.get(`/company/vehicles/${id}/performance?date=${today}`)
        setVehicleDayStats(data)
      } catch (e) {
        toast.error(
          errorApi(
            e,
            'Falha ao carregar dados a respeito do caminho da entrega. Tente novamente mais tarde.',
          ),
        )
      }
      setIsLoading(false)
    }
    loadWaypointsData()
  }, [id, setIsLoading])

  useEffect(() => {
    async function loadRequestsData() {
      try {
        setIsLoading(true)
        const today = new Date().toISOString().split('T')[0]
        let { data } = await api.get(`/company/requests?status=delivered&vehicle_id=${id}&finished_at_begin=${today}`)
        setRequests(data)
      } catch (e) {
        toast.error(
          errorApi(
            e,
            'Falha ao carregar dados das requisições de entrega. Tente novamente mais tarde.',
          ),
        )
      }
      setIsLoading(false)
    }
    loadRequestsData()
  }, [id, setIsLoading])

  const getFormattedRequestDestination = (r: any) => {
    return `${r.street}, ${r.street_number} - ${r.neighborhood}, ${r.city} - ${r.state}`
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Entregas de hoje">
      <LoadingSpinner text="Buscando entregas. Aguarde..." />
      <Container>
        <Row>
          <Col>
            <span className="ml-5">
              <VeiculoRotaDiaria
                requests={requests}
                vehicleId={id}
                role="company"
              ></VeiculoRotaDiaria>
            </span>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <h4 className="mt-4 mt-md-3 mb-3">Histórico de hoje do veículo</h4>
            <span className="ml-5">
              <VehicleHistorical
                vehicleId={id}
                interval={'daily'}
                role="company"
              ></VehicleHistorical>
            </span>
          </Col>
          <Col md={6}>
            <h4 className="mt-4 mb-3">Informações de hoje do veículo</h4>
            {!isLoading && (
              <Row
                className={`${styles.vehicleInfoContainer} border d-flex flex-column justify-content-center align-items-start`}
              >
                <span className={styles.vehicleInfoTitle}>
                  Kms rodados no dia:{' '}
                  <span className={styles.vehicleInfoValue}>
                    {vehicleDayStats!.distance_traveled_kilometers} km
                  </span>
                </span>
                <span className={styles.vehicleInfoTitle}>
                  Entregas no dia:{' '}
                  <span className={styles.vehicleInfoValue}>
                    {vehicleDayStats!.requests_completed}
                  </span>
                </span>
                <span className={styles.vehicleInfoTitle}>
                  Peso transportado no dia:{' '}
                  <span className={styles.vehicleInfoValue}>
                    {vehicleDayStats!.weight_transported} kg
                  </span>
                </span>
                <span className={styles.vehicleInfoTitle}>
                  Combustível abastecido no dia:{' '}
                  <span className={styles.vehicleInfoValue}>
                    {vehicleDayStats!.fuel_consumption} litros
                  </span>
                </span>
              </Row>
            )}
            <h4 className="mt-4 mb-3">Entregas do dia do veículo </h4>
            {!isLoading && (
              <Row
                className={`${styles.dailyRequestsContainer} border d-flex flex-column justify-content-center align-items-start`}
              >
                {!requests.length ? (
                  <Badge bg="#053C5E" text="white" className={styles.badge}>
                    <Warning style={{ marginBottom: 2 }} color="#ffffff" size={15} weight="bold" />{' '}
                    Nenhuma entrega feita hoje
                  </Badge>
                ) : (
                  requests.map((request: any) => (
                    <Col className="col-12" key={request.id} style={{ marginTop: 12 }}>
                      <span style={{ fontSize: 16, fontWeight: 700, marginLeft: 5 }}>
                        Pedido de {request.receiver_name} com nota fiscal nº{' '}
                        {request.invoice.substring(0, 10) + '...'}
                      </span>
                      <span className={styles.dailyRequestsText}>
                        Endereço: {getFormattedRequestDestination(request)}
                      </span>
                      <span className={styles.dailyRequestsText}>
                        Distância percorrida na entrega:{' '}
                        {(request.request_delivery_distance_meters / 1000).toFixed(2)} km
                      </span>
                      <span className={styles.dailyRequestsText}>
                        Tempo decorrido na entrega:{' '}
                        {(request.request_delivery_time_seconds / 60).toFixed(2)} min
                      </span>
                      <span className={styles.dailyRequestsText}>
                        Nota de entrega do motorista:{' '}
                        {request.request_delivery_driver_note || 'Não fornecida.'}
                      </span>
                      <hr style={{ marginLeft: 6, marginTop: 12 }}></hr>
                    </Col>
                  ))
                )}
              </Row>
            )}
          </Col>
        </Row>
      </Container>
    </DashboardLayout>
  )
}

export default Entregas
